export type Props = React.ComponentProps<'svg'>;

export default function IconMember(props: Props) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 21.3984V19.3984C22 17.5346 20.7252 15.9685 19 15.5245M15.5 3.6892C16.9659 4.28258 18 5.71975 18 7.39844C18 9.07713 16.9659 10.5143 15.5 11.1077M17 21.3984C17 19.5347 17 18.6028 16.6955 17.8677C16.2895 16.8876 15.5108 16.1089 14.5307 15.7029C13.7956 15.3984 12.8638 15.3984 11 15.3984H8C6.13623 15.3984 5.20435 15.3984 4.46927 15.7029C3.48915 16.1089 2.71046 16.8876 2.30448 17.8677C2 18.6028 2 19.5347 2 21.3984M13.5 7.39844C13.5 9.60758 11.7091 11.3984 9.5 11.3984C7.29086 11.3984 5.5 9.60758 5.5 7.39844C5.5 5.1893 7.29086 3.39844 9.5 3.39844C11.7091 3.39844 13.5 5.1893 13.5 7.39844Z"
        stroke="#84CAFF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
